import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../index";
export { validateEmailAddress };
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ValidateEmailAddress($email: String!, $clientId: String!) {\n    validateEmailAddress(email: $email, clientId: $clientId) {\n      status\n    }\n  }\n"])));
async function validateEmailAddress(email) {
  var data = await wrapQuery('validateEmailAddress', query, {
    email: email,
    clientId: getClientId()
  });
  return data.validateEmailAddress;
}